import { gql } from "graphql-request";

export const GET_ALL_TRADEDATA_REAL = gql`
  query GetAllTradeData(
    $pageNo: Int
    $pageSize: Int
    $sortBy: String
    $sortType: Int
    $clientId: String
    $tenantId: String
    $searchKeyword: String 
    $filters: Json
    $dateFrom: String
    $dateTo: String
  ) {
    getAllTradeData(
      pageNo: $pageNo
      pageSize: $pageSize
      sortBy: $sortBy
      sortType: $sortType
      clientId: $clientId
      tenantId: $tenantId
      searchKeyword: $searchKeyword
      filters: $filters
      dateFrom: $dateFrom
      dateTo: $dateTo
    ) {
      data
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const GET_TRADE_DATA_COLUMNS = gql`
  query GetTradeDataColumns(
    $clientId: String
    $tenantId: String
  ) {
    getTradeDataColumns(
      clientId: $clientId
      tenantId: $tenantId
    ) {
      data
    }
  }
`;

export const GET_TARIFF_ANALYSIS_FINDINGS = gql`
  query TariffAnalysisFindings($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisFindings(input: $input) {
      data {
        entrySummaryNumber
        entrySummaryLineNumber
        entryDate
        htsNumberFull
        htsDescription
        countryOfOriginCode
        manufacturerID
        manufacturerName
        goodsValue
        aceDuty
        correctDuty
        difference
        finding
        ch99
        ch99Code
        ch99Code2
        ch99CodeList
        ch99Details {
          code
          description
          rate
        }
        ch99Exclusions {
          ch99Code
          description
          nullifiedAuthority
          originalRate
        }
        expectedRate
        expectedBreakdown {
          authority
          rate
          ch99Codes
        }
        aceDutyBreakdown {
          mfnDuty
          mtbDuty
          duty201
          duty232
          duty301
          oth99Duties
        }
        ch99DutyDict
        discrepancyAuthorities
        authorityBreakdown {
          authority
          expectedAmount
          aceAmount
          difference
          codes
        }
        isMetalSplitBundle
        bundledLineNumbers
        metalLines {
          entrySummaryLineNumber
          htsNumberFull
          htsDescription
          goodsValue
          aceDuty
          correctDuty
          expectedRate
          expectedBreakdown {
            authority
            rate
            ch99Codes
          }
          ch99CodeList
          ch99Exclusions {
            ch99Code
            description
            nullifiedAuthority
            originalRate
          }
          aceDutyBreakdown {
            mfnDuty
            mtbDuty
            duty201
            duty232
            duty301
            oth99Duties
          }
          ch99DutyDict
          metalType
        }
        nonMetalLines {
          entrySummaryLineNumber
          htsNumberFull
          htsDescription
          goodsValue
          aceDuty
          correctDuty
          expectedRate
          expectedBreakdown {
            authority
            rate
            ch99Codes
          }
          ch99CodeList
          ch99Exclusions {
            ch99Code
            description
            nullifiedAuthority
            originalRate
          }
          aceDutyBreakdown {
            mfnDuty
            mtbDuty
            duty201
            duty232
            duty301
            oth99Duties
          }
          ch99DutyDict
          metalType
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
      build {
        status
        progress
        uploadTime
        errorMsg
      }
    }
  }
`;

export const GET_TARIFF_ANALYSIS_AUTHORITY_SUMMARY = gql`
  query TariffAnalysisAuthoritySummary($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisAuthoritySummary(input: $input) {
      data {
        authority
        count
        savings
        risk
        net
      }
      build {
        status
        progress
        uploadTime
        errorMsg
      }
    }
  }
`;

export const GET_TARIFF_ANALYSIS_AUTHORITY_HTS_SUMMARY = gql`
  query TariffAnalysisAuthorityHtsSummary($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisAuthorityHtsSummary(input: $input) {
      data {
        htsNumberFull
        htsDescription
        count
        savings
        risk
        net
      }
    }
  }
`;

export const GET_TARIFF_ANALYSIS_AI_BUCKETS = gql`
  query TariffAnalysisAiBuckets($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisAiBuckets(input: $input) {
      data {
        clientId
        findingsCount
        refundFindingsCount
        complianceFindingsCount
        absDollars
        buckets {
          name
          action
          tier
          patternId
          direction
          subKey
          absDollars
          pctOfClient
          netDollars
          findingsCount
          findings {
            entrySummaryNumber
            entrySummaryLineNumber
            entryDate
            htsNumberFull
            htsDescription
            countryOfOriginCode
            manufacturerID
            manufacturerName
            goodsValue
            aceDuty
            correctDuty
            difference
            finding
            ch99
            ch99Code
            ch99Code2
            ch99CodeList
            ch99Details {
              code
              description
              rate
            }
            ch99Exclusions {
              ch99Code
              description
              nullifiedAuthority
              originalRate
            }
            expectedRate
            expectedBreakdown {
              authority
              rate
              ch99Codes
            }
            aceDutyBreakdown {
              mfnDuty
              mtbDuty
              duty201
              duty232
              duty301
              oth99Duties
            }
            ch99DutyDict
            discrepancyAuthorities
            authorityBreakdown {
              authority
              expectedAmount
              aceAmount
              difference
              codes
            }
            isMetalSplitBundle
            bundledLineNumbers
            metalLines {
              entrySummaryLineNumber
              htsNumberFull
              htsDescription
              goodsValue
              aceDuty
              correctDuty
              expectedRate
              expectedBreakdown {
                authority
                rate
                ch99Codes
              }
              ch99CodeList
              ch99Exclusions {
                ch99Code
                description
                nullifiedAuthority
                originalRate
              }
              aceDutyBreakdown {
                mfnDuty
                mtbDuty
                duty201
                duty232
                duty301
                oth99Duties
              }
              ch99DutyDict
              metalType
            }
            nonMetalLines {
              entrySummaryLineNumber
              htsNumberFull
              htsDescription
              goodsValue
              aceDuty
              correctDuty
              expectedRate
              expectedBreakdown {
                authority
                rate
                ch99Codes
              }
              ch99CodeList
              ch99Exclusions {
                ch99Code
                description
                nullifiedAuthority
                originalRate
              }
              aceDutyBreakdown {
                mfnDuty
                mtbDuty
                duty201
                duty232
                duty301
                oth99Duties
              }
              ch99DutyDict
              metalType
            }
          }
          sampleHts
          sampleCh99
          sampleCoo
        }
      }
      build {
        status
        progress
        uploadTime
        errorMsg
      }
    }
  }
`;

export const GET_TARIFF_ANALYSIS_AI_ENRICHMENTS = gql`
  query TariffAnalysisAiEnrichments($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisAiEnrichments(input: $input) {
      data {
        bucketKey
        patternId
        direction
        status
        modelVersion
        iterations
        lastEnrichedAt
        computedAt
        startedAt
        lastHeartbeatAt
        currentStage
        currentTool
        title
        summary
        recommendedAction
        confidence
        verdict
        verdictReason
        citations {
          sourceType
          identifier
          url
          excerpt
          relevance
          verified
        }
        sampledFindingIds
        error
      }
    }
  }
`;

export const TRIGGER_TARIFF_ANALYSIS_AI_ENRICHMENT = gql`
  mutation TriggerTariffAnalysisAiEnrichment($input: TriggerEnrichmentInput!) {
    triggerTariffAnalysisAiEnrichment(input: $input) {
      bucketKey
      status
      iterations
    }
  }
`;

export const TRIGGER_TARIFF_ANALYSIS_AI_ENRICHMENT_BULK = gql`
  mutation TriggerTariffAnalysisAiEnrichmentBulk($input: TriggerEnrichmentBulkInput!) {
    triggerTariffAnalysisAiEnrichmentBulk(input: $input) {
      clientId
      queued
    }
  }
`;

export const GET_TARIFF_ANALYSIS_AUTHORITY_ENTRIES = gql`
  query TariffAnalysisAuthorityEntries($input: TariffAnalysisFindingsInput!) {
    tariffAnalysisAuthorityEntries(input: $input) {
      data {
        entrySummaryNumber
        entrySummaryLineNumber
        entryDate
        htsNumberFull
        htsDescription
        countryOfOriginCode
        manufacturerID
        manufacturerName
        goodsValue
        aceDuty
        correctDuty
        difference
        finding
        ch99
        ch99Code
        ch99Code2
        ch99CodeList
        ch99Details {
          code
          description
          rate
        }
        ch99Exclusions {
          ch99Code
          description
          nullifiedAuthority
          originalRate
        }
        expectedRate
        expectedBreakdown {
          authority
          rate
          ch99Codes
        }
        aceDutyBreakdown {
          mfnDuty
          mtbDuty
          duty201
          duty232
          duty301
          oth99Duties
        }
        ch99DutyDict
        discrepancyAuthorities
        authorityBreakdown {
          authority
          expectedAmount
          aceAmount
          difference
          codes
        }
        isMetalSplitBundle
        bundledLineNumbers
        metalLines {
          entrySummaryLineNumber
          htsNumberFull
          htsDescription
          goodsValue
          aceDuty
          correctDuty
          expectedRate
          expectedBreakdown {
            authority
            rate
            ch99Codes
          }
          ch99CodeList
          ch99Exclusions {
            ch99Code
            description
            nullifiedAuthority
            originalRate
          }
          aceDutyBreakdown {
            mfnDuty
            mtbDuty
            duty201
            duty232
            duty301
            oth99Duties
          }
          ch99DutyDict
          metalType
        }
        nonMetalLines {
          entrySummaryLineNumber
          htsNumberFull
          htsDescription
          goodsValue
          aceDuty
          correctDuty
          expectedRate
          expectedBreakdown {
            authority
            rate
            ch99Codes
          }
          ch99CodeList
          ch99Exclusions {
            ch99Code
            description
            nullifiedAuthority
            originalRate
          }
          aceDutyBreakdown {
            mfnDuty
            mtbDuty
            duty201
            duty232
            duty301
            oth99Duties
          }
          ch99DutyDict
          metalType
        }
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
    }
  }
`;

export const START_TARIFF_ANALYSIS_BUILD = gql`
  mutation StartTariffAnalysisBuild($input: TariffAnalysisFindingsInput!) {
    startTariffAnalysisBuild(input: $input) {
      taskId
      uploadTime
      progressBar
    }
  }
`;

export const CLEAR_TARIFF_RATE_CACHE = gql`
  mutation ClearTariffRateCache($tenantId: String, $clientId: String, $triggerRebuild: Boolean) {
    clearTariffRateCache(tenantId: $tenantId, clientId: $clientId, triggerRebuild: $triggerRebuild)
  }
`;

export const GET_ENTRY_SUMMARIES = gql`
  query GetEntrySummaries(
    $pageNo: Int
    $pageSize: Int
    $sortBy: String
    $sortType: Int
    $clientId: String
    $tenantId: String
    $dateFrom: String
    $dateTo: String
    $filters: EntrySummaryFiltersInput
  ) {
    getEntrySummaries(
      pageNo: $pageNo
      pageSize: $pageSize
      sortBy: $sortBy
      sortType: $sortType
      clientId: $clientId
      tenantId: $tenantId
      dateFrom: $dateFrom
      dateTo: $dateTo
      filters: $filters
    ) {
      data {
        entrySummaryNumber
        lineCount
        totalGoodsValue
        totalLineDuties
        totalMPF
        totalHMF
        entryDate
        filerCode
        portOfEntryCode
        entrySummaryDate
        lines
        latestAuditStatus
        documentCount
        clusterId
        liquidationStatus
        liquidationDate
        entrySummaryVersionNumber
      }
      meta {
        countDocs
        pageNo
        pageSize
      }
      filterOptions {
        availablePorts
        availableCountries
        availableManufacturers
        availableFilerCodes
        availableLiquidationStatuses
      }
    }
  }
`;

export const CREATE_TRADE_DATA = gql`
  mutation CreateTradeData($tradeData: TradeDataInput!) {
    createTradeData(tradeData: $tradeData) {
      data
    }
  }
`;

export const DELETE_TRADE_DATA = gql`
  mutation DeleteAllTradeData($tenantId: String, $clientId: String) {
    deleteAllTradeData(tenantId: $tenantId, clientId: $clientId) {
      data
    }
  }
`;

export const GET_ALL_TRADEDATA_LOGS = gql`
  query GetTasksByTenant($input: TaskQueryInput!) {
    getTasksByTenant(input: $input) {
      taskId
      status
      progress
      uploadTime
      errorMsg
      lastHeartbeat
    }
  }
`;
